import gql from 'graphql-tag'

export const NAME = 'clientOverviewsByOrg'
const GET_CLIENT_OVERVIEWS_BY_ORG = gql`
query ${NAME}($orgId: ID!, $roleTypes: [String], $searchText: String, $completedCourseIds: [ID], $incompleteCourseIds: [ID], $activeSince: Float, $isArchived: Boolean, $skip: Int, $limit: Int, $sortBy: String, $sortOrder: SortOrder, $schoolYear: Int) {
  ${NAME}(orgId: $orgId, roleTypes: $roleTypes, searchText: $searchText, completedCourseIds: $completedCourseIds, incompleteCourseIds: $incompleteCourseIds, activeSince: $activeSince, isArchived: $isArchived, skip: $skip, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder, schoolYear: $schoolYear) {
    totalCount,
    clients {
      id
      orgId
      userName
      roleType
      email
      profile {
        firstName
        lastName
      }
      enrollments {
        id
        courseId
        startedOn
        completedOn
        attemptNumber
        contentItemProgresses {
          ordinal
        }
      }
      lastActiveCourse {
        date
        id
      }
      lastCompletedCourse {
        date
        id
      }
      completedCourseIds
      totalUsageSeconds,
      lastWeekUsageSeconds,
      firePhraseCaptures {
        id
        attemptNumber
        analyzedCaptures {
          sentence
          ignisSeverity
          questionText
        }
      }
      unreviewedFirePhraseCaptures {
        id
        attemptNumber
        analyzedCaptures {
          sentence
          ignisSeverity
          questionText
        }
      }
    }
  }
}
`

export default GET_CLIENT_OVERVIEWS_BY_ORG
